export { default, getStaticProps, getStaticPaths } from "app/[seoArticle]/page";
